import { now } from 'utils/core/now';

import type { IHttpConfig } from '../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  const headers = {
    ...config.headers,
    'Content-Type': 'application/json',
    'timezone-offset': now().getTimezoneOffset().toString(),
  };
  const updatedConfig = {
    ...config,
    headers,
  };
  switch (config.targetHost) {
    case 'SecondaryBridge':
      updatedConfig.url = window.sgmeConfiguration.secondaryBridgeHost + config.url;
      break;
    case 'AdvisoryBridge':
      updatedConfig.url = window.sgmeConfiguration.advisoryBridgeHost + config.url;
      break;
    default:
      updatedConfig.url = window.sgmeConfiguration.spBridgeHost + config.url;
  }
  if (config.body) {
    updatedConfig.body = JSON.stringify(config.body);
  }

  return updatedConfig;
};
